import React from 'react';
import PromptsPage from './PromptsPage';
import { IUser } from '../../types/damTypes';

interface PromptsModuleProps {
  onClose: () => void;
  currentUser: IUser | null;
}

const PromptsModule: React.FC<PromptsModuleProps> = ({ onClose, currentUser }) => {
  return <PromptsPage onClose={onClose} currentUser={currentUser} />;
};

export default PromptsModule;
